// Inbound WhatsApp contact link. A static wa.me link only: no WhatsApp Business API, no
// sending, no BSP (Director decision). ELE's WhatsApp number is the single client phone
// 0203 576 4760, whose wa.me form is 442035764760. The link opens a WhatsApp conversation
// with the ELE business number in a new tab. Used on external-facing pages only (never the
// office, admin or engineer surfaces). Session ACG: rendered in the ELE brand green #63C41F
// (the WhatsApp brand lime is a RETIRED colour, banned platform-wide by
// colourLint.test.ts -- never reintroduce it).
//
// Session AHT: this component is rendered on THREE pages, and only one of them is a
// light-canvas document. The flat #63C41F default renders on the two dark-canvas pages
// (SubcontractorOnboarding's dark shell, PortalShell's dark footer) at a comfortable 8.97:1
// and must stay exactly as it is there. On the quote accept page's light canvas the same
// flat value measures only ~2:1, an AA failure -- but darkening the shared constant globally
// would fix that page while silently regressing the other two below AA on their dark ground.
// The `color` prop lets ONE light-canvas caller opt into a darker ink without touching the
// component's default or the other two callers' rendered output at all.
export const WHATSAPP_NUMBER_E164 = "442035764760";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER_E164}`;
const WHATSAPP_GREEN = "#63C41F";

export function WhatsAppLink({ className = "", color = WHATSAPP_GREEN }: { className?: string; color?: string }) {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Message East London Elevators on WhatsApp"
      style={{ color }}
      className={`font-menu ${className}`.trim()}
    >
      WhatsApp us
    </a>
  );
}
